import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

/**
 * Testimonial Routes and Pages
 */
const ListTestimonialPage = React.lazy(() => import("./ListTestimonialPage"));
const AddTestimonialPage = React.lazy(() => import("./AddTestimonialPage.js"));
const EditTestimonialPage = React.lazy(() =>
  import("./EditTestimonialPage.js")
);

const TestimonialRoutes = () => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListTestimonialPage />} />
      <Route exact path="/add" element={<AddTestimonialPage />} />
      <Route exact path="/edit/:id" element={<EditTestimonialPage />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};

export default TestimonialRoutes;
